import Vue from 'vue'
import axios from 'axios'

function getCurrentPrice(fields, enabledFields) {
  const enabledFieldsIds = enabledFields.map(field => field._id)
  return Object.keys(fields).reduce((sum, fieldId) => {
    if (!enabledFieldsIds.includes(fieldId)) return sum
    const field = fields[fieldId].value
    if (Array.isArray(field)) {
      sum += field.reduce((s, v) => {
        if (v.price) {
          if (v.count) s += parseFloat(v.price) * parseFloat(v.count)
          else s += parseFloat(v.price)
        }
        return s
      }, 0)
    } else {
      if (field && field.price) {
        if (field.count) {
          sum += parseFloat(field.price) * parseFloat(field.count)
        } else sum += parseFloat(field.price)
      }
    }
    return sum
  }, 0)
}
const initialOrder = {
  fieldsValues: {},
  orderComment: '',
  currentPrice: 0
}

export default {
  namespaced: true,
  state: {
    order: {
      fieldsValues: {},
      currentPrice: 0
    },
    enabledFields: [],
    valid: false,
    error: null,
    loading: false
  },
  mutations: {
    setOrderComment(state, comment) {
      state.order = {
        ...state.order,
        orderComment: comment
      }
    },
    setEnabledFields(state, enabledFields) {
      state.enabledFields = [...enabledFields]
      state.order.currentPrice = getCurrentPrice(state.order.fieldsValues, state.enabledFields)
      state.order = {
        ...state.order
      }
    },
    setFieldValue(state, field) {
      state.order = {
        fieldsValues: {
          ...state.order.fieldsValues,
          [field.id]: { ...field }
        }
      }

      state.order.currentPrice = getCurrentPrice(state.order.fieldsValues, state.enabledFields)
    },
    setInitialFieldsValue(state, initialOrderFieldsValues) {
      state.order = {
        fieldsValues: { ...initialOrderFieldsValues },
        currentPrice: getCurrentPrice(state.order.fieldsValues, state.enabledFields)
      }
    },
    setOrder(state, order) {
      state.order = {
        ...order
      }
    },
    setLoading(state, isLoading) {
      state.loading = isLoading
    },
    setError(state, error) {
      state.error = error
    }
  },
  actions: {
    setOrderComment({ commit }, comment) {
      commit('setOrderComment', comment)
    },
    setEnabledFields({ commit }, enabledFields) {
      commit('setEnabledFields', enabledFields)
    },
    clearEditedOrder({ commit }) {
      commit('setError', null)
      commit('setLoading', false)
      commit('setOrder', initialOrder)
    },
    setFieldValue({ commit }, field) {
      commit('setFieldValue', field)
    },
    setInitialFieldsValue({ commit }, initialOrderFieldsValues) {
      commit('setInitialFieldsValue', initialOrderFieldsValues)
    },
    loadOrderById({ commit }, orderId) {
      commit('setLoading', true)
      commit('setError', null)
      axios
        .get(`${config.apiUrl}/orders/${orderId}`)
        .then(res => res.data.order)
        .then(order => {
          commit('setOrder', order)
        })
        .catch(err => {
          commit('setError', err)
        })
        .finally(() => commit('setLoading', false))
    }
  },
  getters: {
    getEditedOrder: state => {
      return state.order
    },
    isLoading: state => {
      return state.loading
    },
    isError: state => {
      return state.error
    }
  }
}
